var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "info_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.996 13.792a.532.532 0 00.387-.156.52.52 0 00.159-.386V9.542A.526.526 0 0010.004 9a.532.532 0 00-.387.156.52.52 0 00-.158.386v3.708a.526.526 0 00.537.542zm0-6.052a.581.581 0 00.594-.585.581.581 0 00-.585-.594.581.581 0 00-.594.585.581.581 0 00.585.594zm.011 9.843a7.409 7.409 0 01-2.947-.592 7.647 7.647 0 01-2.42-1.63 7.643 7.643 0 01-1.63-2.418 7.408 7.408 0 01-.593-2.951c0-1.047.197-2.028.592-2.943a7.644 7.644 0 014.048-4.04 7.408 7.408 0 012.951-.592c1.047 0 2.028.197 2.943.592a7.678 7.678 0 014.04 4.043 7.36 7.36 0 01.593 2.94 7.407 7.407 0 01-.593 2.948 7.646 7.646 0 01-1.629 2.42 7.66 7.66 0 01-2.413 1.63 7.36 7.36 0 01-2.941.593zM10 16.5c1.806 0 3.34-.632 4.604-1.896C15.868 13.34 16.5 11.806 16.5 10s-.632-3.34-1.896-4.604C13.341 4.132 11.806 3.5 10 3.5c-1.805 0-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.195 16.5 10 16.5z",
    fill: "#7A8D8F"
  }))));
}
export default SvgInfo;